import { render } from "./BMedia.vue?vue&type=template&id=cec30f3c&scoped=true"
const script = {}

import "./BMedia.vue?vue&type=style&index=0&id=cec30f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec30f3c"]])

export default __exports__